import cabri from "../app/cabri-app";
import {GeomObject} from "./geom-object";
import * as BABYLON from "babylonjs/babylon.max";

class Plane extends GeomObject {

    constructor (a, b, c, d) {
        if (arguments.length == 1) {
            super(a);
            this.position = [0, 0, 1, 0];
            this.forceUpdateInNextCycle = true;
            this.color = this.getColorAttribute("surface_color1", "#7F7F7F");
        }
        else
            if (arguments.length == 4) {
                super(cabri.emsc.createPlane3(`(${a},${b},${c},${d})`));
                this.position = [0, 0, 1, 0];
                this.forceUpdateInNextCycle = true;
            }
    }

    createTile () {
        if (this.noDisplay || this.hidden) return;
        if (this.bjsPlanes) {
            this.bjsPlanes.forEach(t => t.dispose(false, true));
        }
        const q = this.position, p = [0,0,0,0];
        // let's normalize p
        //const n = Math.sqrt(q[0] ** 2 + q[1] ** 2 + q[2] ** 2);
        const n = Math.sqrt(q[0]*q[0] + q[1]*q[1] + q[2]*q[2]);
        for (let i = 0; i < 4; i++)
            p[i] = q[i]/n;
        // we assume Cabri's coordinates are a,b,c,d where a∙x+b∙y+c∙z+d =0
        // (same as <v | p> = 0) BabylonJS' coordinates claim to be
        // m∙x+n∙y+o∙z+p = 0 but that seems wrong for p we'll use
        // FromPositionAndNormal and have to guess a point for this
        let o;
        if (p[0] !== 0)           // a ≠ 0 => x = (-d-b-c)/a, y=1, z=1 is a solution
            o = [(-p[3] - p[1] - p[2])/p[0], 1, 1]
        else if (p[1] !== 0)      // b ≠ 0 => x = 1, y=(-d-a-c)/b, z=1 is a solution
            o = [1, (-p[3] - p[0] - p[2])/p[1], 1]
        else if (p[2] !== 0)      // c ≠ 0 => x = 1, y=1, z=(-d-a-b)/c is a solution
            o = [1, 1, (-p[3] - p[0] - p[1])/p[2]]
        else
            throw "All three normal params cannot be null."

        const delta = 0; // 0.02 / Math.sqrt(p[0]**2+p[1]**2+p[2]**2 );
        // delta is so that ax'+by'+cz' = d+delta (a,b,c)ᵀ ∙ (x',y',z')ᵀ =
        // d+delta with (x',y',z') = (x,y,z)+ λ ∙ (a,b,c) (and (x,y,z) belongs
        // to the first plane) hence a∙(x+λa) + b∙(y+λb) + c∙(z+λc) = ax+by+cz
        // + λ∙(a²+b²+c²) = d + λ∙(a²+b²+c²) One wishes that |λ ∙ (a,b,c)|==
        // 0.1 hence λ = 0.1 / |(a,b,c)|
        const plane1 = BABYLON.Plane.FromPositionAndNormal(
            new BABYLON.Vector3(o[0], o[2], o[1]),
            new BABYLON.Vector3(p[0], p[2], p[1]));
        /* const plane2 = BABYLON.Plane.FromPositionAndNormal(new BABYLON.Vector3(o[0], o[2], o[1]),
         new BABYLON.Vector3(-p[0], -p[2], -p[1])); */

// side of base plane (square) in Cabri3D is 12 cm long
        this.bjsPlanes = [
            BABYLON.MeshBuilder.CreatePlane("plane",
                {
                    size: 12,
                    sideOrientation: BABYLON.Mesh.DOUBLESIDE,
                    sourcePlane: plane1,
                    updatable: true,
                }, cabri.scene),
                /* BABYLON.MeshBuilder.CreatePlane("plane",
                 {size: 12,
                 sourcePlane: plane2, updatable: true}, cabri.scene) */
                //BABYLON.MeshBuilder.CreatePlane("plane",
                //{size: 12, sourcePlane: plane2, updatable: true}, cabri.scene)
            ];
        //this.bjsPlanes[1].isVisible = false;

        //this.color = "#FFFFFF";     // currently "ivory" now "white"

        // TODO: something more spatial than a thin plane: e.g. a box (if we
        // can rotate them)?
        this.bjsPlanes.forEach(plane => {
            super.markColor(plane, this.color, {alpha: 0.8});
            plane.cabriPeer = this;
        });
        // TODO jml  suppress the array of bjsPlanes (no need because wwe have just one)
        this.bjsPlanes[0].material.alpha = 0.8;
    }

    updateFromPeer () {
        let p;
        try {
            if (typeof (this.objectId) === "undefined")
                return;
            p = cabri.emsc.getPlane3Coords(this.objectId);
            let q = this.position;
            this.updatedInLastCycle = this.forceUpdateInNextCycle;
            if (this.updatedInLastCycle ||
                    p[0] !== q[0] || p[1] !== q[1] ||
                    p[2] !== q[2] || p[3] !== q[3]) {
                for(let i=0; i<4; i++) q[i] = p[i];
                this.createTile();
                this.forceUpdateInNextCycle = false;
            }
        } catch (e) {
            console.log(
                "Trouble at updateFromPeer (" + this.constructor.name + ").");
            console.log(e);
        } finally {
            if (p) cabri.emsc._free(p);
        }
    }

    dispose () {
        if (this.bjsPlanes) {
            for (let p of this.bjsPlanes) {
                p.dispose(false, true);
            }
        }
        super.dispose();
    }

}

export {Plane};